module.exports = __webpack_public_path__ + "static/media/stockxX.d50ca240.svg";